__turbopack_context__.v({
  "pbs_kids_logo": "PBSKidsSearchRow-module-scss-module__FdMq9a__pbs_kids_logo",
  "pbs_kids_search_row": "PBSKidsSearchRow-module-scss-module__FdMq9a__pbs_kids_search_row",
  "pbs_kids_search_row__button": "PBSKidsSearchRow-module-scss-module__FdMq9a__pbs_kids_search_row__button",
  "pbs_kids_search_row__content": "PBSKidsSearchRow-module-scss-module__FdMq9a__pbs_kids_search_row__content",
  "pbs_kids_search_row__description": "PBSKidsSearchRow-module-scss-module__FdMq9a__pbs_kids_search_row__description",
  "pbs_kids_search_row__image": "PBSKidsSearchRow-module-scss-module__FdMq9a__pbs_kids_search_row__image",
});
